import { render, staticRenderFns } from "./wyModalSignPatientGuardian.vue?vue&type=template&id=09347676&"
import script from "./wyModalSignPatientGuardian.vue?vue&type=script&lang=js&"
export * from "./wyModalSignPatientGuardian.vue?vue&type=script&lang=js&"
import style0 from "./wyModalSignPatientGuardian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports